import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { devLog } from '@/utils/logger';
import { toast } from 'sonner';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ── Service Worker registration + update prompt ───────────────────────
// When a deploy ships a new SW, we surface a single "App updated — reload
// to apply" toast. Tapping Reload tells the waiting SW to skipWaiting and
// then refreshes the page so the user gets the new JS bundle. Without this
// the user could be stuck on stale JS for an entire session.
if ('serviceWorker' in navigator) {
  const promptUpdate = (waitingSw) => {
    if (!waitingSw) return;
    toast('App updated', {
      description: 'A new version is ready. Reload to apply.',
      duration: Infinity,
      action: {
        label: 'Reload',
        onClick: () => {
          waitingSw.postMessage({ type: 'SKIP_WAITING' });
        },
      },
    });
  };

  // When the controller changes (the new SW activated), reload once so
  // the page picks up the new chunks. Guarded so the page doesn't loop.
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => {
        devLog('SW registered:', reg.scope);

        // A waiting SW already exists at boot (user has stale tabs open).
        if (reg.waiting && navigator.serviceWorker.controller) {
          promptUpdate(reg.waiting);
        }

        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // A NEW worker installed AND the page is currently controlled
              // by the OLD one → there's a real update to apply.
              promptUpdate(reg.waiting || installing);
            }
          });
        });
      },
      (err) => devLog('SW registration failed:', err)
    );
  });
}
